import { Failure } from '@mrhenry/failure';
import { html, TemplateResult } from 'lit';
import { BookingRequest, Dispatcher } from '../../types/booking-request';
import { showStepWhenCurrentIs, stepId, STEP_PERSONAL_DETAILS } from '../../types/steps';
import { WPContent } from '../../types/wp-data';
import { agreeToTermsInput } from './partials/agree-to-terms-input';
import { confirmRequestInput } from './partials/confirm-request-input';
import { emailInput } from './partials/email-input';
import { feedbackTextarea } from './partials/feedback-textarea';
import { fullNameInput } from './partials/full-name-input';
import { makeBookingRequestButton } from './partials/make-booking-request-button';
import { telephoneInput } from './partials/phone-input';
import { stepIntro } from './partials/step-intro';

export function stepPersonalDetails(
	state: BookingRequest,
	dispatch: Dispatcher,
	assetUrl: string,
	content: WPContent
): TemplateResult {
	if ( !( showStepWhenCurrentIs( STEP_PERSONAL_DETAILS, state.currentStep ) ) ) {
		return html``;
	}

	let failure = html``;
	if ( Failure.isFailure( state.bookingFailure ) ) {
		failure = html`
			<fieldset class="form__group theme-color-error">
				${state.bookingFailure?.message}
			</p>
		`;
	}

	return html`
		<div class="step" id="${stepId( STEP_PERSONAL_DETAILS )}">
			<div class="section theme-grey-light">
				<div class="wrapper">
					<div class="double-columns">
						<div class="double-columns__column">
							${stepIntro( content.titlePersonalDetails, content.textPersonalDetails )}
						</div>

						<div class="double-columns__column">
							<div class="form type-f">
								<fieldset class="form__group">
									${fullNameInput( state.personalDetails.fullName, dispatch, assetUrl, state.personalDetails.fullNameFailure )}
									${emailInput( state.personalDetails.email, dispatch, assetUrl, state.personalDetails.emailFailure )}
									${telephoneInput( state.personalDetails.telephone, dispatch, assetUrl, state.personalDetails.telephoneFailure )}
									${feedbackTextarea( state.personalDetails.feedback, dispatch )}
									${agreeToTermsInput( state.personalDetails.agreeToTerms, dispatch, assetUrl, content.termsLink, state.personalDetails.agreeToTermsFailure )}
									${confirmRequestInput( state.personalDetails.confirmRequest, dispatch, assetUrl, state.personalDetails.confirmRequestFailure )}
								</fieldset>

								${failure}

								<fieldset class="form__group">
									${makeBookingRequestButton( state, dispatch )}
								</fieldset>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	`;
}
